module.exports = __webpack_public_path__ + "img/messageblack.287e018f.svg";